import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider as ReactRouterProvider } from 'react-router-dom';

import { RouteErrorBoundary } from '@components/route-error-boundary';
import { useGoogleAnalytics } from '@hooks/use-google-analytics';

import { useCurrentUserQuery } from 'api/authentication/hooks';

import { AuthenticatedNavigation } from './authenticated/navigation';

const PreboardingCompanyNavigation = lazy(() => import('./preboarding-company/navigation'));
const PreboardingUserNavigation = lazy(() => import('./preboarding-user/navigation'));
const UnauthenticatedNavigation = lazy(() => import('./unauthenticated/navigation'));

const Root = () => {
  const currentUser = useCurrentUserQuery();
  useGoogleAnalytics();

  if (currentUser.isLoading) {
    return null;
  }

  const Navigation = currentUser.data
    ? currentUser.data.company.hasFinishedPreboarding
      ? currentUser.data.hasFinishedPreboarding
        ? AuthenticatedNavigation
        : PreboardingUserNavigation
      : PreboardingCompanyNavigation
    : UnauthenticatedNavigation;

  return (
    <Suspense fallback={null}>
      <Navigation />
    </Suspense>
  );
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <Root />,
    errorElement: <RouteErrorBoundary />,
  },
]);

export const isInTemplateRoute = () => {
  return router.state.location.pathname.startsWith('/templates/');
};

export const RouterProvider = () => <ReactRouterProvider router={router} />;
